import axios from "axios";

const BrowserPrint = window.BrowserPrint;
const ZebraPrinter = window.Zebra;

export const Errors = {
  ZebraBrowserPrintNotInstalled: () => {},
  NoPrinterFound: () => {},
  MultiplePrinterFound: printers => ({ printers }),
  UnknownPrinter: () => {},
  PrinterNotReady: () => {},
  NoisPrinterSelected: () => {},
};

class Zebra {
  getPrinters() {
    return new Promise(resolve =>
      BrowserPrint.getLocalDevices(deviceList => {
        resolve(deviceList.printer);
      }),
    );
  }

  getStatus() {
    return new Promise(resolve =>
      this.zebraPrinter.getStatus(status => {
        resolve({
          offline: status.offline,
          paperOut: status.paperOut,
          paused: status.paused,
        });
      }),
    );
  }

  sendToPrinter(content) {
    return new Promise((resolve, reject) =>
      this.printer.send(
        content,
        function (success) {
          resolve();
        },
        function (error) {
          reject(error);
        },
      ),
    );
  }

  async initialize(requiredIp) {
    try {
      // test 9100 port
      await axios.get("http://127.0.0.1:9100/available");
    } catch (error) {
      throw new Error("ZebraBrowserPrintNotInstalled");
    }
    if (!BrowserPrint || !ZebraPrinter) throw new Error("ZebraBrowserPrintNotInstalled");

    const printers = await this.getPrinters();
    if (!printers) throw Error("NoPrinterFound");

    this.printerList = printers.map(p => p.name);
    if (printers.length === 0) throw Error("NoPrinterFound");

    let selected = printers[0];
    for (let printer of printers) {
      if (printer.uid === requiredIp) selected = printer;
    }

    await this.selectPrinter(selected.name, printers);
  }

  async selectPrinter(name, printers) {
    const printersLst = printers || (await this.getPrinters());
    const lPrinter = printersLst.find(p => p.name === name);

    if (!lPrinter) throw Error.UnknownPrinter();

    this.printerName = name;
    this.connexion = lPrinter.connection;
    this.printerIp = lPrinter.uid;
    this.printer = lPrinter;
    this.zebraPrinter = new ZebraPrinter.Printer(lPrinter);
    this.isPrinterSelected = true;
  }

  async print(zpl) {
    try {
      await this.zebraPrinter.isPrinterReady();
    } catch (error) {
      console.error(error);
      throw Error("PrinterNotAvailable", { error });
    }

    try {
      await this.sendToPrinter(zpl);
    } catch (error) {
      console.error(error);
      throw new Error("PrintFailed");
    }
  }
}

export default Zebra;
